angular.module('app.favorites.favoritesService', [])
  .factory('app.favorites.favoritesService', [
    '$http', '$httpParamSerializerJQLike', '$rootScope', '$q', 'appKey',
    function ($http, $httpParamSerializerJQLike, $rootScope, $q, appKey) {
      let favorites = {
        list: null,
        error: null,
        selected: null,
        retrieving: false,
        retrieving_terms: false,

        clear: function () {
          favorites.list = {
            personal: null,
            public: null
          };
          favorites.error = null;
          favorites.selected = [10];
        },
        retrieve: function (params) {
          if (appKey.user_key) {
            if (favorites.retrieving) {
              let deferred = $q.defer();
              deferred.reject({error: 'Already in process of retrieving favorites'});
              return deferred.promise;
            }
            else {
              favorites.retrieving = true;
              favorites.error = null;
              params = $httpParamSerializerJQLike(params);
              return $http.get(window.location.api('favorites?' + params))
                .then(function (response) {
                  let data = response.data;

                  if (data.personal) {
                    favorites.list.personal = data.personal;
                  }
                  if (data["public"]) {
                    favorites.list["public"] = data["public"];
                  }
                  if (data.error) {
                    favorites.error = data.error;
                  }

                  if(_.isEmpty(favorites.selected) || _.isEqual([10], favorites.selected)) {
                    favorites.select(10, true);
                  }

                  $rootScope.$broadcast('favorites_changed');

                  favorites.retrieving = false;
                });
            }

          }
          else {
            let deferred = $q.defer();
            deferred.reject({error: 'User is not logged in'});
            return deferred.promise;
          }
        },
        retrieve_if_empty: function (params) {
          if (!(favorites.list["personal"] && favorites.list["public"])) {
            return favorites.retrieve(params);
          }
        },
        add: function (type, search_id) {
          return $http.post(window.location.api('favorites'), {
            type: type,
            search_id: search_id
          })
            .then((response) => {
              let data = response.data;

              if (data.id) {
                if (!Array.isArray(favorites.list.personal)) {
                  favorites.list.personal = [];
                }
                favorites.list.personal.push(data);
                $rootScope.$broadcast('favorites_updated');
              }
            });
        },
        "delete": function (id) {
          return $http["delete"](window.location.api('favorites/' + id))
            .then(() => {
              if (Array.isArray(favorites.list.personal)) {
                favorites.list.personal = favorites.list.personal.filter(
                  /**
                   * @param {Object} item
                   * @returns {boolean}
                   */
                  (item) => {
                    return item.id !== id;
                  }
                );
                $rootScope.$broadcast('favorites_updated');
              }
            });
        },
        find_favorite: function (type, search_id) {
          let favorite, i, len, ref;
          if (Array.isArray(favorites.list.personal)) {
            ref = favorites.list.personal;
            for (i = 0, len = ref.length; i < len; i++) {
              favorite = ref[i];
              if (favorite.type === type && parseInt(favorite.search_id) === parseInt(search_id)) {
                return favorite;
              }
            }
          }
          return false;
        },
        is_favorite: function (type, search_id) {
          return !!favorites.find_favorite(type, search_id);
        },
        toggle: function (type, search_id) {
          let favorite;
          favorite = favorites.find_favorite(type, search_id);
          if (favorite) {
            return favorites["delete"](favorite.id);
          } else {
            return favorites.add(type, search_id);
          }
        },
        is_selected: function (id) {
          if (id == 10) {
            if (Array.isArray(favorites.selected)) {
              return favorites.selected.length === 0;
            }
            return true;
          }

          return favorites.selected.indexOf(id) !== -1;
        },
        select: function (id, noBroadcastFlag) {
          if (id === 10 || favorites.is_selected(10)) {
            favorites.selected = [];
          }
          if (!favorites.is_selected(id)) {
            favorites.selected.push(id);

          }
          if (!noBroadcastFlag) {
            $rootScope.$broadcast('favorites_selected');
          } else {
            return true;
          }

        },
        deselect: function (id) {
          let index;
          index = favorites.selected.indexOf(id);
          if (index !== -1) {
            favorites.selected.splice(index, 1);
          }
          $rootScope.$broadcast('favorites_selected');
        },
        toggle_selected: function (id) {
          if (favorites.is_selected(id)) {
            return favorites.deselect(id);
          } else {
            return favorites.select(id);
          }
        },
        _debounceGetTerms: _.debounce((deferred) => {
          if (appKey.user_key) {
            $http.get(window.location.api('favorites/terms'))
              .then((response) => {
                deferred.resolve(response);
              });
          }
          else {
            deferred.reject({error: 'User is not logged in'});
          }
        }, 300),
        getTerms: function () {
          let deferred = $q.defer();

          favorites._debounceGetTerms(deferred);

          return deferred.promise;
        },
        hasSelected: () => {
          if (Array.isArray(favorites.selected) && favorites.selected.length) {
            return !(favorites.selected.length === 1 && favorites.selected[0] == 10);
          }
          return false;
        }
      };

      favorites.clear();
      return favorites;
    }
  ]);


// WEBPACK FOOTER //
// ./app.v2/components/favorites/favoritesService.js